import React from 'react';
import type { ResolvedPhoneShell } from 'magical-trails';

import PhoneGlyph from './PhoneGlyph';
import { phoneStyleVars } from './phoneStyle';
import type { HomeApp } from './PhoneHome';

export interface Props {
  shell: ResolvedPhoneShell;
  apps: HomeApp[];
}

/**
 * The `layout: 'dock'` presentation: the map stays the main screen and the
 * apps sit in a bar under it, where TrailFooter sits in the standard player.
 */
const PhoneDock: React.FC<Props> = ({ shell, apps }) => (
  <nav
    className="Trail_footer Phone_dock"
    aria-label="Apps"
    data-ph-theme={shell.theme}
    style={phoneStyleVars(shell)}
  >
    <ul>
      {apps.map((app) => (
        <li key={app.id}>
          <button
            type="button"
            className="Phone_dockApp"
            onClick={app.onOpen}
            // Label first, then the count: "Messages, 2 unread".
            aria-label={
              app.badge ? `${app.label}, ${app.badge} unread` : app.label
            }
          >
            <span className={`Phone_appTile Phone_appTile-${app.id}`}>
              <PhoneGlyph glyph={app.id} theme={shell.theme} />
              {app.badge ? (
                <span className="Phone_badge Phone_badge-corner">
                  {app.badge}
                  <span className="sr-only"> unread</span>
                </span>
              ) : null}
            </span>
            <span className="Phone_appLabel">{app.label}</span>
          </button>
        </li>
      ))}
    </ul>
  </nav>
);

export default PhoneDock;
